import i18n from 'i18n-js'
import memoize from 'lodash.memoize'

const translationGetters = (lang: string) => {
  const englishLocales = [
    'en-029',
    'en-AU',
    'en-BZ',
    'en-CA',
    'en-cb',
    'en-GB',
    'en-IE',
    'en-IN',
    'en-JM',
    'en-MT',
    'en-MY',
    'en-NZ',
    'en-PH',
    'en-SG',
    'en-TT',
    'en-US',
    'en-ZA',
    'en-ZW'
  ]

  if (englishLocales.includes(lang)) {
    return require('../assets/locales/en.json')
  }

  return require('../assets/locales/nb.json')
}

const translate = memoize(
  (key, config = null) => i18n.t(key, config),
  (key, config) => (config ? key + JSON.stringify(config) : key)
)

const setI18nConfig = () => {
  const fallback = { languageTag: 'en' }
  const { languageTag } = { languageTag: navigator.language } || fallback

  if (translate && translate.cache && translate.cache.clear)
    translate.cache.clear()

  i18n.translations = { [languageTag]: translationGetters(languageTag) }
  i18n.locale = languageTag
  i18n.missingTranslation = () => null
  Promise.resolve()
}

export { setI18nConfig, translate as t, translate }
